<template>
  <div class="page">
    <header>
      <NavBar :title="lang('我的积分')"> </NavBar>
    </header>
    <div class="stickyCard" :style="{ opacity: cardOpacity }">
      <img src="@/assets/images/score/scoreIcon.png" />
      <div class="rightBox">
        <div class="textBox">
          <p class="textName">{{ lang('我的积分') }}</p>
          <p class="textValue">{{ score }}</p>
        </div>
        <div class="btnBox">
          <van-button class="btn" round :plain="true" @click="toRecharge"
            >Points recharge</van-button
          >
        </div>
      </div>
    </div>
    <main>
      <PullRefresh
        v-model:refreshing="refreshing"
        :scroll-height="'100%'"
        class="pull"
        @on-refresh="onRefresh"
      >
        <div ref="targetElement" style="margin: 0 12px">
          <ScoreCard
            :score="score"
            :total-points="totalPoints"
            :bonus-points="bonusPoints"
            @click="(value) => click(value)"
          />
          <div style="margin-bottom: 22px" />
          <TitleCommon />
          <div style="margin-bottom: 8px" />
        </div>
        <van-list
          v-if="dataList.length > 0"
          v-model:loading="loading"
          :finished="finished"
          :finished-text="lang('没有更多了')"
          :loading-text="''"
          @load="loadMore"
        >
          <div class="grid-container">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              class="grid-item"
            >
              <goods-card :data="item" @to-detail="toDetail(item)" />
            </div>
          </div>
        </van-list>
        <no-data v-if="finished && dataList.length === 0" />
      </PullRefresh>
      <!--      </div>-->
    </main>
  </div>
</template>

<script lang="ts" setup name="ScoreList">
import NavBar from '@core/components/NavBar.vue'
import { useRouter } from 'vue-router'
import lang from '@/langs'
import ScoreCard from '@/views/score/component/scoreMain/scoreCard.vue'
import TitleCommon from '@/views/score/component/scoreMain/title.vue'
import { ref, onMounted, onUnmounted, nextTick, watch, onActivated } from 'vue'
import GoodsCard from '@/views/score/component/scoreMain/goodsCard.vue'
import PullRefresh from '@core/components/PullRefresh.vue'
import Line from '@core/components/line.vue'
import usePagination from '@core/utils/usePagination'
import { getGoodsList, getMyScore } from '@/api/requests/score'
import { GoodsRecordModal } from '@/model/score/GoodsModel'
import { useUserStore } from '@core/stores/user'
import NoData from '@core/components/NoData.vue'

const router = useRouter()
const list = ref([1, 1, 1, 1, 1, 1, 1, 1, 1])
const cardOpacity = ref(0)
const targetElement = ref<HTMLElement | null>(null) // 目标元素的引用
const isVisible = ref(false) // 标记目标元素是否可见
const score = ref(0)
const totalPoints = ref(0)
const bonusPoints = ref(0)
let observer: IntersectionObserver | null = null
const getScore = () => {
  getMyScore({ stationCode: useUserStore().nativeInfo.stationCode }).then(
    (value) => {
      if (value.code === 1) {
        score.value = value.data.pointsAmount
        totalPoints.value = value.data.totalPoints
        bonusPoints.value = value.data.bonusPoints
      }
    }
  )
}
const handleIntersect = (entries: IntersectionObserverEntry[]) => {
  entries.forEach((entry) => {
    isVisible.value = entry.isIntersecting
  })
}
const onRefresh = () => {
  getScore()
  refreshFn()
}
const toRecharge = () => {
  router.push({
    path: '/scoreCharge',
    query: { isH5: 'true' }
  })
}
onActivated(() => {
  getScore()
})
onMounted(() => {
  fetchPageData()
  getScore()
  nextTick(() => {
    if (targetElement.value) {
      observer = new IntersectionObserver(handleIntersect, {
        threshold: 0.1 // 目标元素至少有10%可见时触发
      })
      observer.observe(targetElement.value)
    }
  })
})

onUnmounted(() => {
  if (observer && targetElement.value) {
    observer.unobserve(targetElement.value)
  }
})
// 监听 isVisible 变化，执行逻辑
watch(isVisible, (newValue, oldValue) => {
  if (newValue) {
    // 元素变得可见时，执行的逻辑
    cardOpacity.value = 0
    console.log('元素进入视口，执行加载或动画逻辑')
  } else {
    cardOpacity.value = 1

    // 元素离开视口时，执行的逻辑
    console.log('元素离开视口，停止加载或动画')
  }
})
const {
  param,
  dataList,
  loading,
  finished,
  refreshing,
  fetchPageData,
  refreshFn,
  loadMore
} = usePagination(getGoodsList)

const toDetail = (item: GoodsRecordModal) => {
  router.push({
    path: '/goodsDetail',
    query: { data: item.salesPriceId, isH5: 'true' }
  })
}
const click = (value: number) => {
  router.push({ path: '/scoreDetail', query: { type: value } })
}
</script>
<script lang="ts">
export default {
  name: 'ScoreMain'
}
</script>
<style lang="less" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  position: relative;
  > main {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: scroll;
    .pull {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    //.list {
    //  flex: 1;
    //  display: flex;
    //  overflow: scroll;
    //  width: 100%;
    .grid-container {
      display: grid;
      margin: 5px 12px;
      flex: 1;
      grid-template-columns: repeat(2, 1fr); /* 定义每行两列 */
      gap: 12px; /* 列间距和行间距 */
      background: #fff;
      padding: 12px;
      border-radius: 8px;
    }

    .grid-item {
      background: #fff; /* 可选：设置背景，便于观察 */
      border-radius: 5px;
    }
    //}
  }
  .stickyCard {
    position: absolute;
    top: 45px;
    background: white;
    padding: 7px 14px;
    transition: opacity 0.3s ease; /* 平滑过渡 */
    width: 100%;
    z-index: 99;
    display: flex;
    flex-direction: row;
    align-items: center;
    box-shadow: 0px 3.33px 6.67px rgba(0, 0, 0, 0.05);
    > img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .rightBox {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .textBox {
        color: black;
        .textName {
          font-size: 13px;
        }
        .textValue {
          font-size: 19px;
          font-weight: 700;
        }
      }
      .btnBox {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 100%;
        .btn {
          width: 100%;
          background: linear-gradient(
            90deg,
            rgba(250, 81, 15, 1),
            rgba(255, 0, 0, 1) 100%
          ); /* 从左到右的渐变 */
          color: #fff;
          font-size: 10px;
          height: 21px;
          padding: 5px 7px;
          border: none;
        }
      }
    }
  }
}
</style>
